export default __webpack_public_path__ + "static/media/shop_3.666e43c4.png";